/* eslint-disable no-unused-vars */
import api from '@/store/Api'

const dataLayer = {
  GetItemsInPageById: pageId => {
    return new Promise((resolve, reject) => {
      api
        .get(`/LivetMisc/Livet/GetItemsInPageById/${pageId}`)
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  GetPageById: pageId => {
    return new Promise((resolve, reject) => {
      api
        .get(`/LivetMisc/Livet/GetPageById/${pageId}`)
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  }
}
export default dataLayer
